import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';
import {
  orgSnowflakeStatusesUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { OrgSnowflakeStatusesResponse } from '@/lib/portfolio/snowflake-types';

export function useOrgSnowflakeStatuses(portfolioId: number) {
  return useQuery<OrgSnowflakeStatusesResponse>({
    queryKey: portfolioQueryKeys.orgSnowflakeStatuses(portfolioId),
    queryFn: () =>
      apiGet<OrgSnowflakeStatusesResponse>(
        orgSnowflakeStatusesUrl(portfolioId)
      ),
    enabled: Number.isFinite(portfolioId),
    staleTime: 30_000,
    // The app-wide QueryClient sets refetchOnWindowFocus: false
    // (lib/crm/query/queryClient.ts), so we OPT IN here: after an org admin
    // approves/declines/revokes elsewhere, returning to this tab refetches and the row reflects the
    // new status without a hard reload — the issue's "refetch-on-focus is enough" mechanism
    // (real-time/WebSocket is explicitly out of scope).
    refetchOnWindowFocus: true,
    retry: false,
  });
}
